
<div style="padding: 10px">
  @if (!isCompareVersionsTab) {
    <h2 [routerLink]="['../../../']">Modules</h2>
  }
  @if (!isCompareVersionsTab) {
    <h3>{{routeModuleId}} Change Comparison</h3>
  }
  @if (isCompareVersionsTab) {
    <h3>Compare Changes</h3>
  }
  @if (!isCompareVersionsTab) {
    <div class="input-box">
      <mat-form-field style="padding: 10px;">
        <mat-select placeholder="Select Left Side" [(ngModel)]="this.baseTextSelection">
          <mat-option value="live">Live Version</mat-option>
          <mat-option value="changes">Changes</mat-option>
          <mat-option value="snapshot">Snapshot</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-button color="primary" (click)="this.update()">Update</button>
      <mat-form-field style="padding: 10px;">
        <mat-select placeholder="Select Right Side" [(ngModel)]="compareTextSelection">
          <mat-option value="live">Live Version</mat-option>
          <mat-option value="changes">Changes</mat-option>
          <mat-option value="snapshot">Snapshot</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (isCompareVersionsTab) {
    <form class="compare-versions-input" [formGroup]="compareForm" (ngSubmit)="compareVersions()">
      <mat-form-field>
        <mat-select placeholder="Select Module" formControlName="moduleUniqueId" (selectionChange)="onModuleChange()">
          @for (module of modulesWithVersions; track module) {
            <mat-option [value]="module.ModuleId">
              {{ module.ModuleId }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Deployed Version From" formControlName="versionFrom">
          @for (version of availableVersions; track version) {
            <mat-option [value]="version">
              {{ version }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Deployed Version To" formControlName="versionTo">
          @for (version of availableVersions; track version) {
            <mat-option [value]="version">
              {{ version }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" type="submit">Compare</button>
    </form>
  }
  <div class="input-box left">
    <div>
      @if (formChanges) {
        <button mat-raised-button color="primary" (click)="setStateCompare()">Show State Changes</button>
      }
      @if (!formChanges) {
        <button mat-raised-button color="primary" (click)="setFormCompare()">Show Form Changes</button>
      }
    </div>
    <div>
      <select [(ngModel)]="contextSize">
        <option [value]="25">25</option>
        <option [value]="50">50</option>
        <option [value]="75">75</option>
        <option [value]="150">150</option>
        <option [value]="300">300</option>
      </select>
    </div>
    <div>
      Inline Diff<input type="checkbox" [(ngModel)]="inline"/>
    </div>
  </div>
</div>
<div class="comparison-grid" #comparison>
  <div class="loading-status">
    @if (this.loadstatus!=='unableToLoad' && !isCompareVersionsTab) {
      <div>
        <h2>Loading</h2>
        <mat-spinner></mat-spinner>
      </div>
    }
    @if (this.loadstatus==='unableToLoad' && !isCompareVersionsTab) {
      <div>
        <h2>Unable to load</h2>
      </div>
    }
    @if (compareChangesLoading && isCompareVersionsTab) {
      <div>
        <h2>Loading</h2>
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
</div>
